import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getRowData } from "@/api/dataAll/rowData";
import addLinks from "./components/addLinks";
import clipboard from "@/utils/clipboard";
export default {
  name: "montorowData",
  props: {
    reqFnt: {
      type: null,
      default: function _default() {
        return getRowData;
      }
    }
  },
  components: {
    addLinks: addLinks
  },
  mixins: [tabulation],
  data: function data() {
    return {
      value2: [],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      searchData: {
        page: 1,
        type: ""
      },
      typeArr: [{
        id: "1",
        type_name: "click"
      }, {
        id: "2",
        type_name: "show"
      }],
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: [],
      adPlacementSingleChoice: true,
      more: true
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    searchClick: function searchClick() {
      var _this = this;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.searchData.kind = 1;
      this.reqLoading = true;
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == "valuets" ? [""] : searchData.ad_placement;
      this.reqFnt(this.searchData).then(function (res) {
        _this.tableData = res.data.data || [];
        _this.total = res.data.total - 0 || 0;

        _this.$nextTick(function () {
          _this.getTableRight();
        });
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this2 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this2.$refs.addWayConfig.init(id, num);
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      clipboard(text, event);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteLink'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLinksList({
                  id: id
                }).then(function (res) {
                  _this3.searchClick();
                });

                _this3.$message({
                  type: "success",
                  message: _this3.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: "id"
      }, {
        label: this.$t('date'),
        prop: "timestamp"
      }, {
        label: this.$t('game'),
        prop: "game"
      }, {
        label: this.$t('platform'),
        prop: "platform"
      }, {
        label: this.$t('channel'),
        prop: "channel"
      }, {
        label: this.$t('adChannel'),
        prop: "ad_channel"
      }, {
        label: this.$t('adPlacement'),
        prop: "ad_placement"
      }, {
        label: this.$t('pkg'),
        prop: "pkg"
      }, {
        label: this.$t('adPlanName'),
        prop: "aid_name"
      }, {
        label: this.$t('adCreativeName'),
        prop: "campaign_name"
      }, {
        label: this.$t('adStyle'),
        prop: "ctype"
      }, {
        label: this.$t('system'),
        prop: "os"
      }];
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};